<template>
  <!-- Page Content -->
  <div class="login-wrapper account-page cont_login" style="position: relative;">
    <div class="content">
      <div class="sobrefondo" style="background-color: rgba(0, 0, 0, 0.3) !important"></div>
      <!-- Login Content -->
      <div class="account-content">
        <div class="align-items-center justify-content-center">
          <div class="login-right">
            <div class="login-header text-center">
              <router-link to="/home/"
                ><img src="@/assets/talento_agv/img/AV_Logo_NEW_Purple_RGB_800.png" alt="logo" class="img-fluid" style="width: 120px;"
              /></router-link>
              <h3>Bienvenido! Un gusto verte de nuevo</h3>
            </div>
            <form @submit.prevent="onSubmit" class="mt-4">
              <div class="form-group">
                <label>Correo Electronico</label>
                <input type="email" class="form-control" v-model="email" required ref="first_input"/>
              </div>
              <div class="form-group">
                <label>Contraseña</label>
                <input type="password" class="form-control" v-model="password" required/>
              </div>

              <button
              class="btn btn-agv w-100 btn-lg login-btn d-flex align-items-center justify-content-center mt-5"
              type="submit" :disabled="loading"
              >
                Ingresar
                <i v-if="!loading" class="feather-arrow-right ms-2"></i>
                <i v-else class="feather-loader ms-2"></i>
              </button>
              <div class="row">
                <div class="col-sm-12 dont-have d-flex align-items-center">
                  No tienes una cuenta?
                  <router-link to="/crear_cuenta" class="ms-2">Crear cuenta</router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- /Login Content -->
    </div>
    <!-- <img src="@/assets/talento_agv/img/vector_uno.png" alt="" style="position:absolute; z-index: 50; height: 80%; top:0; left:0; margin-bottom: -50px; transform:rotate(180deg)"> -->
    <!-- <img class="vector-rayas" src="@/assets/talento_agv/img/vector_uno.png" alt="" style="position:absolute; z-index: 50; height: 100%; bottom:0; right:0;"> -->
  </div>
  <!-- /Page Content -->

  <!-- Pie de Página -->
  <footeragv></footeragv>
</template>
<style>
  @media(max-width:1220px){
      .cont_login .vector-rayas{
          height: 50% !important;
      }
  }

  @media(max-width:800px){
      .cont_login .vector-rayas{
          height: 40% !important;
      }
  }

  @media(max-width:700px){
      .cont_login .vector-rayas{
          height: 30% !important;
      }
  }

  @media(max-width:600px){
      .cont_login .vector-rayas{
          height: 20% !important;
      }
  }
  
  @media(max-width:500px){
      .cont_login .vector-rayas{
          display: none;
      }
  }
</style>
<script>
import { ref } from 'vue';
import axiosIns from '@/plugins/axios.js';
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import { router } from "@/router";
export default {
  components: {
    Form,
    Field,
  },
  data() {
    return {
      loading: false,
      showPassword: false,
      email:null,
      password: null,
      emailError: "",
      passwordError: "",
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    onSubmit() {
      this.emailError = "";
      this.passwordError = "";
      this.loading = true

      const yo = this       
      const data = JSON.stringify({
        email : yo.email,
        password : yo.password,
      })

      const config = {
        method: 'post',
        url: '/talentoagv/loginApplicant/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data,
      }

      axiosIns(config)
        .then(function (response) {
          console.log(response.data)
          if (response.data['is_error'] === false){
            let u = response.data['result']
            // let photo;
            // if(u.s3_url){
            //   photo = u.s3_url
            // }else{
            //   photo = '@/assets/img/arandanito.png'
            // }
            localStorage.setItem('userData', JSON.stringify({
              
              'nombres_completos': u.name + ' ' + u.first_surname + ' ' + u.second_surname,
              'nombres': u.name,
              'ap_paterno': u.first_surname,
              'ap_materno': u.second_surname,
              'username': u.username,
              'email': u.email,
              'photo': u.s3_url,
              // 'photo': photo,
              'id_usuario': u.id,

            }))
            yo.$toastr.success(response.data['message'], 'Éxito')
            yo.$router.push("/dashboard_ofertas_laborales");
          }else{
            yo.$toastr.success(response.data['message'], 'Error de autenticación')
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toastr.error(response.data['message'], 'Error')
        })
        .finally(function (){
          yo.loading = false
        })


    },
  },
  setup() {
    let users = localStorage.getItem("storedData");
    if (users === null) {
      let password = [
        {
          email: "example@correo.com",
          password: "123456",
        },
      ];
      const jsonData = JSON.stringify(password);
      localStorage.setItem("storedData", jsonData);
    }
    const schema = Yup.object().shape({
      email: Yup.string().required("Email is required").email("Email is invalid"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    });
    return {
      schema,
    };
  },
};

</script>
